import script from "./SchoolDaySISOrganizations.vue?vue&type=script&setup=true&lang=ts"
export * from "./SchoolDaySISOrganizations.vue?vue&type=script&setup=true&lang=ts"

import "./SchoolDaySISOrganizations.vue?vue&type=style&index=0&id=7dc3a6d2&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dc3a6d2"]])

export default __exports__